import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation UpsertDocument($params: UpsertDocumentInput!) {
    upsertDocument(params: $params) {
      id
    }
  }
`;

export type UpsertDocumentFn = (
  params: UpdateRasterParams | SaveYieldAnalysisParams | SaveZoneAnalysisParams
) => void;

export interface UpdateRasterParams {
  id: string;
  kind: 'raster-ndvi' | 'raster-truecolor' | 'raster-falsecolor';
  thumbnailUrl: string;
  bins?: NdviRasterBins;
}

export interface SaveYieldAnalysisParams {
  kind: 'yield-analysis';
  farmId: string;
  fieldId: string;
  rasterUrl: string;
  vectorUrl: string;
  thumbnailUrl: string;
  documentIds: string[];
}

export interface SaveZoneAnalysisParams {
  kind: 'zone-analysis';
  farmId: string;
  fieldId: string;
  rasterUrl: string;
  thumbnailUrl: string;
  labels: { value: number; points: number }[];
  sourceId: string;
}

interface Result {
  upsertDocument: Farm;
}

interface Props {
  onCompleted: (data: Farm) => void;
  children: (execute: UpsertDocumentFn, loading: boolean) => React.ReactNode;
}

const UpsertDocumentProvider: React.StatelessComponent<Props> = (
  props: Props
) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={(data: Result) => props.onCompleted(data.upsertDocument)}
    >
      {(mutateFn, result) =>
        props.children(
          (
            params:
              | UpdateRasterParams
              | SaveYieldAnalysisParams
              | SaveZoneAnalysisParams
          ) => mutateFn({ variables: { params } }),
          result.loading
        )
      }
    </AuthorizedMutation>
  );
};

export default UpsertDocumentProvider;



// WEBPACK FOOTER //
// ./src/providers/UpsertDocumentProvider.tsx